<script>
import VOtpInput from "vue3-otp-input";
import {ref} from "vue";
import {useRoute} from "vue-router";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import {useStore} from "vuex";
import {useTimer} from "vue-timer-hook";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import router from "@/router";
import useClipboard from "vue-clipboard3";


export default {
  name: "OtpPage",
  components: {LoadingPage, VOtpInput},
  setup() {

    let store = useStore()

    let loading = ref(false)
    let data = ref({
      phone: useRoute().params.phone,
      otp: '',
    })
    let user_type = FreeWorld.PinkMan(store.state.user_type , 'de')

    let x = ref(useRoute().params.otp)

    let id = null

    const time = new Date();
    time.setSeconds(time.getSeconds() + 50);
    const timer = useTimer(time);

    function send_code() {
      if (data.value.otp.length !== 4) {Swals.Warning('لطفا کد ارسال شده را وارد کنید!');return false}

      loading.value = true
      FreeWorld.Heisenberg(data.value, 'login_otp').then((res) => {
        loading.value = false
        if (res.data.status === 'ok') {
          if (res.data.event === 'user not exist') {

            user_type === 1 ? router.push({name: 'RegisterPage', params: {phone: data.value.phone}}) : router.push({name: 'W_SignUp', params: {phone: data.value.phone}})

          } else if (res.data.event === 'user exist') {

            store.commit('set_helpers' , true)

            if (user_type === 1) {
              let uid = FreeWorld.PinkMan(res.data.user_id , 'en')
              id = res.data.user_id
              localStorage.setItem('uid' , uid)
              runApp_user()
            } else {
              let uid = FreeWorld.PinkMan(res.data.user_id , 'en')
              id = res.data.user_id
              localStorage.setItem('uid' , uid)
              runApp_worker()
            }
          }
        } else if (res.data.event === 'otp is wrong') {
          Swals.Fault('کد وارد شده صحیح نمی باشد!')
        } else if(res.data.event === 'user not verify'){
          Swals.Fault('متاسفانه مشخصات شما هنوز تایید نشده است!')
        }else if(res.data.event === 'user disable') {
          Swals.Fault('متاسفانه کاربری شما تعلیق شده است!')
        }else {
          Swals.Fault('متاسفانه مشکلی پیش آمده است!')
        }

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, send_code)
      })
    }

    function try_code() {
      const time = new Date();
      time.setSeconds(time.getSeconds() + 50);
      timer.restart(time);

      loading.value = true
      FreeWorld.Heisenberg({phone: data.value.phone}, 'login_phone').then((res) => {
        loading.value = false
        if (res.data.status === 'ok') {
          Swals.Done('پیامک حاوی کد ورود برای شما ارسال گردید')
        } else {
          Swals.Fault('متاسفانه مشکلی پیش آمده است!')
        }
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, try_code)
      })

    }

    function runApp_user() {
      loading.value = true

      FreeWorld.Heisenberg({action: 'city'}, 'public_info').then((res) => {

        store.commit('set_country', res.data)
        let country = res.data

        FreeWorld.Heisenberg({action: 'user_info' , user_id:id}, 'public_info').then((res) => {

          country.forEach((item) => {
            if (item.id === res.data.state_id) {
              res.data.state = item.name
              item.city.forEach((item_city) => {
                if (item_city.id === res.data.city_id) {
                  res.data.city = item_city.name
                  return false
                }
              })
            }
          })

          store.commit('set_profile', res.data)

          FreeWorld.Heisenberg({action: 'slider' , user_id:id}, 'public_info').then((res) => {

            store.commit('set_slider', res.data)

            FreeWorld.Heisenberg({action: 'tell'}, 'public_info').then((res) => {

              store.commit('set_info_support', res.data)

              FreeWorld.Heisenberg({action: 'adver_category'}, 'public_info').then((res) => {

                store.commit('set_category', res.data)

                  loading.value = false
                  window.location.href = '/HomePage'

              }).catch((res) => {
                loading.value = false
                Swals.Catch(res, runApp_user)
              })

            }).catch((res) => {
              loading.value = false
              Swals.Catch(res, runApp_user)
            })

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, runApp_user)
          })

        }).catch((res) => {
          loading.value = false
          Swals.Catch(res, runApp_user)
        })

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, runApp_user)
      })
    }

    function runApp_worker() {
      loading.value = true

      FreeWorld.Heisenberg({action: 'user_info' , user_id:id}, 'public_info').then((res) => {

        store.commit('set_profile', res.data)

        FreeWorld.Heisenberg({action: 'slider' , user_id:id}, 'public_info').then((res) => {

          store.commit('set_slider', res.data)


          FreeWorld.Heisenberg({action: 'city'}, 'public_info').then((res) => {

            store.commit('set_country', res.data)

            FreeWorld.Heisenberg({action: 'tell'}, 'public_info').then((res) => {

              store.commit('set_info_support', res.data)

                loading.value = false
                window.location.href = '/W_HomePage'

            }).catch((res) => {
              loading.value = false
              Swals.Catch(res, runApp_worker)
            })

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, runApp_worker)
          })

        }).catch((res) => {
          loading.value = false
          Swals.Catch(res, runApp_worker)
        })

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, runApp_worker)
      })
    }

    let show_support = ref(true)
    const {toClipboard} = useClipboard()
    async function call_support() {
      let phone_support = store.state.info.phone
      await Swals.Dialog(phone_support, null, 'کپی کردن', 'انصراف').then(async (res) => {
        if (res.isConfirmed) {
          try {
            await toClipboard(phone_support)
            Swals.Done('شماره پشتیبانی با موفقیت کپی شد');
          } catch (e) {
            Swals.Fault('متاسفانه شماره پشتیبانی کپی نشد!');
          }
        }
      });
    }

    return {
      data,
      send_code,
      loading,
      timer,
      try_code,
      call_support,
      show_support,
      x
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div class="" :class="loading ? 'activeClass':''" id="main">

    <div class="holder-logo rounded-bottom-5 w-100 max_width">
      <div class="position-relative w-100 h-100 d-flex justify-content-center align-items-start">
        <img class="img_logo" src="../assets/img/logoapp.png" alt="">

        <div class="list-access bg-white rounded-4 p-2 shadow-custom">
          <div class="position-relative">
            <div class="rounded-pill text-white shadow-custom font-5 bg-color-liner p-3">
              <p class="text-center font-bold">ارسال کد</p>
            </div>

            <p class="font-5 text-center mb-3 mt-4">لطفا کد ارسال شده را وارد کنید</p>

            <div dir="ltr" class="mb-3">
              <v-otp-input
                  class="w-100 justify-content-center align-items-center"
                  v-model:value="data.otp"
                  input-classes="input_otp bg-white mx-2 text-center p-2 rounded-pill shadow-custom"
                  :num-inputs="4"
                  separator=" "
                  :placeholder="['', '', '', '']"
                  :should-auto-focus="true"
                  input-type="letter-numeric"
                  :conditionalClass="['one', 'two', 'three', 'four']"
                  @on-complete="send_code"
                  @focusin="show_support = false"
                  @focusout="show_support = true"
              />
            </div>

            <p class="">{{x}}</p>

            <p class="font-4 text-center mb-3">00:{{ timer.seconds }}</p>

            <div class="mb-6 d-flex align-items-center justify-content-between px-5">
              <p v-if="timer.isExpired.value" @click="try_code" class="font-5">ارسال مجدد</p>
              <router-link :to="{name:'LoginPage'}" class="font-5 text-black">ویرایش شماره</router-link>
            </div>

            <div class="btn-center w-100 d-flex justify-content-center position-absolute">
              <div @click="send_code" class="p-1 bg-white w-50 shadow-custom rounded-pill">
                <p class="bg-color-liner p-3 text-center text-white font-bold rounded-pill">ثبت</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="show_support" class="position-fixed w-100 max_width d-flex bottom-1">
      <a href="https://sangin-savaran.com/" target="_blank" class="bg-color-light text-decoration-none p-1 d-flex align-items-center rounded-pill me-2 shadow">
        <img style="width: 3rem" class="icon_shadow" src="../assets/img/icon-call-bg-white.svg" alt="">
        <p class="font-5 text-color mx-3">کمک بگیرید</p>
      </a>
    </div>
  </div>

</template>

<style scoped>
.img_logo {
  width: 35%;
  margin-top: 55px;
}

.holder-logo {
  background-image: linear-gradient(to bottom left, #46E2FF, #268EE0, #0335BE);
  position: fixed;
  top: 0;
  height: 45%;
}

.list-access {
  position: absolute;
  bottom: -15rem;
  width: 80%;
}

.btn-center {
  bottom: -6.6rem;
}
</style>